import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  lastName: Yup.string().required(),
  firstName: Yup.string().required(),
  email: Yup.string().required().email(),
  password: Yup.string().required(),
  repeatedPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Slaptažodžiai nesutampa')
    .required(),
  company: Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.number().required(),
    email: Yup.string().required().email(),
    phone: Yup.number().required(),
  }),
});